module.exports = __webpack_public_path__ + "static/media/left.0652cf0e.svg";